import { render, staticRenderFns } from "./ModifyInteraction.vue?vue&type=template&id=274cff30"
import script from "./ModifyInteraction.vue?vue&type=script&lang=js"
export * from "./ModifyInteraction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports